import { useCallback, useEffect, useRef } from "react";
import AssetCoverToast from "../../../../../common/features/asset/AssetCoverToast.tsx";
import { useIntl } from "react-intl";
import { useAssetReturnFetcher } from "./return.ts";
import useToasts from "../../../../root/core-ui/toast/useToasts.ts";

export default function useAssetReturn(asset?: {
  vbid: string;
  title: string;
}): () => void {
  const fetcher = useAssetReturnFetcher();
  const { showToast } = useToasts();
  const intl = useIntl();
  const shouldShowToastRef = useRef(false);

  const doReturn = useCallback(() => {
    if (fetcher.state === "idle") {
      shouldShowToastRef.current = true;
      fetcher.submit(
        {},
        {
          action: `/actions/return/${asset?.vbid}`,
          method: "POST",
        }
      );
    }
  }, [fetcher, asset?.vbid]);

  useEffect(() => {
    if (
      asset &&
      shouldShowToastRef.current &&
      fetcher.state === "loading" &&
      typeof fetcher.data?.ok === "boolean"
    ) {
      shouldShowToastRef.current = false;
      if (fetcher.data.ok) {
        showToast(
          <AssetCoverToast
            vbid={asset.vbid}
            type="success"
            title={intl.formatMessage(
              { defaultMessage: "{title} has been returned." },
              { title: asset.title }
            )}
          />
        );
      } else {
        showToast(
          <AssetCoverToast
            vbid={asset.vbid}
            type="error"
            title={intl.formatMessage(
              {
                defaultMessage: "An error occurred returning {title}.",
              },
              { title: asset.title }
            )}
          />
        );
      }
    }
  }, [intl, showToast, asset, fetcher]);

  return doReturn;
}
